import React from 'react';
import ContactForm from '../components/ContactForm';
import '../styles/landing.css';

const Contact = () => {
  return (
    <div className="page-contact">
      <section className="page-header">
        <span className="page-header__eyebrow">Get in Touch</span>
        <h1 className="page-header__title">Contact Us</h1>
        <p className="page-header__subtitle">
          Have questions about our media monitoring services? We'd love to hear from you.
        </p>
      </section>

      <div className="contact-layout container">
        <div className="contact-info-card">
          <div className="contact-info-card__inner">
            <h2 className="contact-info-card__title">Our Office</h2>
            <p className="contact-info-card__note">
              Thank you for making time to contact Record News. Please note, we provide a service for media monitoring companies and cannot respond to questions about general information or current coverage.
            </p>

            <div className="contact-detail">
              <div className="contact-detail__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 2C6.13 2 3 5.13 3 9c0 5.25 7 11 7 11s7-5.75 7-11c0-3.87-3.13-7-7-7z" stroke="currentColor" strokeWidth="1.5"/><circle cx="10" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.5"/></svg>
              </div>
              <address className="contact-detail__text">
                152 Van Dalen South<br />
                Willowbrook<br />
                Roodepoort, 1724<br />
                South Africa
              </address>
            </div>
          </div>
        </div>

        <div className="contact-form-card">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;
